import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DataBlocks, I18n } from 'components';

import { Device } from '../Device';
import { getFTTBConnectedDevices } from '../../store/selectors';

const _DeviceBlock = ({ connectedDevices }) => {
  if (!connectedDevices?.length) return null;

  return (
    <DataBlocks.Block title={<I18n path="internet.devices.blockTitle" />}>
      {connectedDevices.map((device) => <Device key={device.routerSerial} {...device} />)}
    </DataBlocks.Block>
  );
};

const mapStateToProps = (state) => ({
  connectedDevices: getFTTBConnectedDevices(state),
});

_DeviceBlock.propTypes = {
  connectedDevices: PropTypes.arrayOf({
    routerSerial: PropTypes.string,
  }),
};

export const DeviceBlock = connect(mapStateToProps)(_DeviceBlock);
